import { Options } from '../options.interface';
import { HttpClient } from '@angular/common/http';
import { Injectable, InjectionToken, inject } from '@angular/core';
import { Contact, ContactResource, toContact } from '@wizbii/utils/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface ContactApiConfig {
  baseUrl: string;
  appId: string;
  locale: string;
}

export const CONTACT_API_CONFIG = new InjectionToken<ContactApiConfig>('CONTACT_API_CONFIG');

@Injectable()
export class ContactWebservice {
  readonly #http = inject(HttpClient);
  readonly #contentApiConfig = inject(CONTACT_API_CONFIG);

  readonly #baseUrl = this.#contentApiConfig.baseUrl;
  readonly #appId = this.#contentApiConfig.appId;
  readonly #locale = this.#contentApiConfig.locale;

  /**
   * Send an email from a contat form
   * @param {Object} contact Object defining the contact
   * @param {Object} [options] Angular Options for the request
   */
  send(contact: ContactResource, options?: Options): Observable<Contact> {
    return this.#http
      .post(
        `${this.#baseUrl}/v1/contact/${this.#locale}`,
        {
          ...contact,
          appId: this.#appId,
        },
        options
      )
      .pipe(map(toContact));
  }
}
